// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"uS-z","inlineTitle":"vS-z","sponsoredAdsWrapper":"wS-z","marketplaceRecosWrapper":"xS-z"};